import { combineReducers } from 'redux';
import { payoutDetails } from './payment-payout-details/payment-payout-details.reducer';

export const scriptHelpersReducer = combineReducers({
  payoutDetails,
});
